var React = require('react');

function Disarm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.1 4A5.002 5.002 0 0 1 13 5v2h1c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h9.1V5c0-1.71-1.39-3.1-3.1-3.1-1.36 0-2.518.88-2.935 2.1H3.1zM8 16c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z","fill":"currentColor","fillRule":"evenodd"}));
}

Disarm.defaultProps = {"width":"16","height":"21","viewBox":"0 0 16 21"};

module.exports = Disarm;

Disarm.default = Disarm;
